import { Link } from 'react-router-dom';
import SmileSadIcon from '@app/assets/icons/smile-sad.svg?react';

interface SubscriptionExpiredModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SubscriptionExpiredModal = ({ isOpen, onClose }: SubscriptionExpiredModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg max-w-lg w-full mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center space-x-3">
            <span className="text-2xl"><SmileSadIcon /></span>
            <h2 className="text-xl font-bold text-gray-800">Subscription Expired</h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <p className="text-gray-800 mb-6">
            Your subscription has expired and access to the features is now locked. To continue enjoying our services, please renew your subscription or choose a new plan.
          </p>

          {/* Call to Action */}
          <div className="text-center">
            <Link
              to="/subscription-renewal"
              onClick={onClose}
              className="inline-block w-full bg-brand-baseBlue text-white font-bold py-3 px-6 rounded-lg"
            >
              Renew Subscription
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
